{
  "calibrations": {
    "title": "Calibraciones",
    "create_new": "Ejecutar nueva calibración",
    "serials": "Números de serie",
    "from": "Desde",
    "to": "Hasta",
    "manage_actions": {
      "transfer": "Transferir",
      "reset": "Restablecer",
      "identify": "Identificar",
      "run": "Ejecutar nueva calibración"
    }
  }
}
